<template>
  <button
    class="back-button"
    @click.prevent.stop="$emit('goBack')"
  >
    <slot name="label"> Back </slot>
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"

@Options({
  name: "BackButtonComponent",
  components: {}
})
export default class BackButtonComponent extends Vue {}
</script>
